import { render, staticRenderFns } from "./AiQuestionaryEdit.vue?vue&type=template&id=55eaba9f&"
import script from "./AiQuestionaryEdit.vue?vue&type=script&lang=ts&"
export * from "./AiQuestionaryEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports